<div class="py-[30px]">
  <div [formGroup]="form">
    <!-- reservations   -->
    <div>
      <div class="flex flex-row items-center justify-between">
        <div>
          <div class="v4-layout-form mr-[20px]">
            <div class="v4-layout-form-title">
              {{ "property-property_detail-advanced_html_订单" | translate }}
              <!-- Reservations -->
            </div>
            <div class="v4-layout-form-desc">
              {{ "property-rt_detail-advanced_html_订单说明" | translate }}
              <!-- View all reservations of properties that include this room type. -->
            </div>
          </div>
        </div>
        <div>
          <button nz-button nzSize="large" (click)="toResvPage()">
            {{ "word.view" | translate }}
            <!-- View -->
          </button>
        </div>
      </div>
    </div>

    <div class="mt-[36px]">
      <div class="flex flex-row items-center justify-between">
        <div>
          <div class="v4-layout-form mr-[20px]">
            <div class="v4-layout-form-title">{{ "house.allow_overbooking" | translate }}</div>
            <div class="v4-layout-form-desc">{{ "house.set_allow_house_overbook_info" | translate }}</div>
          </div>
        </div>
        <div>
          <nz-switch formControlName="is_allowed_overbooking"></nz-switch>
        </div>
      </div>
      <ng-container *ngIf="oversaleDateItems.length">
        <div class="v4-option-list mt-3">
          <div class="v4-option-item" *ngFor="let item of oversaleDateItems; let index = index">
            <div class="v4-option">
              <img
                *ngIf="item.thirdparty_type !== undefined"
                [src]="(item.thirdparty_type | thirdparty)?.icon_color"
                class="w-[18px] h-[18px] rounded-full mr-1" />
              <span>{{ item.from | dateformat: ["YMD"] }}</span>
              <span *ngIf="item.from !== item.to">&nbsp;~&nbsp;{{ item.to | dateformat: ["YMD"] }}</span>
              <span class="ml-2 cursor-pointer" (click)="onDeleteDateItem(item, index)">x</span>
            </div>
          </div>
        </div>
        <a nz-button nzType="link" (click)="onClickAddDateItem()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          <!-- 超售日期 -->
          {{ "house.overbooking_date" | translate }}
        </a>
      </ng-container>
    </div>

    <div class="mt-[36px]">
      <div class="flex flex-row items-center justify-between">
        <div>
          <div class="v4-layout-form mr-[20px]">
            <div class="v4-layout-form-title">{{ "house.stop_managing_reserve_automatically_info" | translate }}</div>
            <div class="v4-layout-form-desc">
              {{ "house.click_to_stop_managing_reserve_automatically" | translate }}
            </div>
          </div>
        </div>
        <div>
          <nz-switch formControlName="is_stop_managing_inventory"></nz-switch>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form mt-[36px]">
    <div class="v4-layout-form-title !mb-0">
      {{ "word.house" | translate }}
      <!-- Properties -->
    </div>
    <div class="">
      <div class="flex flex-row items-center justify-between">
        <v4-common-house-list-filter [form]="searchForm"></v4-common-house-list-filter>
        <div>
          <button nz-button nzType="primary" (click)="onAddHouse()">
            {{ "component.sidebar.btn.add_house" | translate }}
            <!-- Add property -->
          </button>
        </div>
      </div>
      <nz-table
        class="v4-layout-list"
        #nzTable
        [nzData]="listOfHouse"
        [nzFrontPagination]="false"
        [nzTotal]="total"
        [(nzPageIndex)]="page"
        [nzPageSize]="pageSize"
        [nzPaginationType]="'small'"
        [nzShowTotal]="totalTpl"
        (nzPageIndexChange)="onPageChange()">
        <thead>
          <tr>
            <th>
              {{ "property-house_display_html_th_房源姓名" | translate }}
              <!-- Name -->
            </th>
            <th>
              {{ "property-house_display_html_th_关联的房源" | translate }}
              <!-- Linked Listings -->
            </th>
            <!-- <th>
              {{ "word.tag" | translate }}
              Tags
            </th> -->
            <th></th>
          </tr>
        </thead>
        <tbody class="v4-layout-list-body">
          <tr *ngFor="let house of nzTable.data">
            <td>
              <v4-widget-image-caption
                [img]="house.cover_picture || '/assets/status/placeholder.png'"
                [caption]="house.house_title">
              </v4-widget-image-caption>
            </td>
            <td>
              <nz-avatar-group *ngIf="house.thirdparty_types?.length; else connectAccount">
                <nz-avatar
                  *ngFor="let channel of house.thirdparty_types"
                  [nzSrc]="(channel | thirdparty)?.icon_color_bg"></nz-avatar>
              </nz-avatar-group>
              <ng-template #connectAccount>
                <img class="w-8 h-8 cursor-pointer" src="/assets/v4/icon-list-placeholder.svg" />
              </ng-template>
            </td>
            <!-- <td>
              <div class="v4-tag-list">
                <div class="v4-tag-item py-1 mr-3" *ngFor="let tag of house.tags">
                  <div class="v4-tag" [style.backgroundColor]="tag.color">
                    {{ tag.name }}
                  </div>
                </div>
              </div>
            </td> -->
            <td (click)="$event.stopPropagation()">
              <div class="text-right">
                <button class="no-min-width" nz-button nz-dropdown [nzDropdownMenu]="dropdownMenu">
                  <i nz-icon nzType="ellipsis" nzTheme="outline"></i>
                </button>
              </div>
              <nz-dropdown-menu #dropdownMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="onViewCalendar(house.id)">
                    {{ "property-house_display_html_查看日历" | translate }}
                    <!-- View calendar -->
                  </li>
                  <li nz-menu-item (click)="onEditHouse(house)">
                    {{ "word.edit" | translate }}
                    <!-- Edit -->
                  </li>
                  <li nz-menu-item (click)="onRemoveHouse(house)">
                    {{ "word.remove" | translate }}
                    <!-- Remove -->
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTpl>
        {{ "component-page_html_总数" | translate: { number: total } }}
        <!-- {{ total }} items -->
      </ng-template>
    </div>
  </div>
</div>
